var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"momazon-header-container"},[_c('div',{staticClass:"momazon-logo-container"},[_c('a',{staticClass:"momazon-logo-link",attrs:{"href":"/"}},[_vm._v(" DynamicDeals ")])])])
}]

export { render, staticRenderFns }